const SHEETS_API_KEY = import.meta.env.VITE_GOOGLE_SHEETS_API_KEY; // Replace with your actual API key
const SPREADSHEET_ID = '1fWX4_c5Jqi7cZCIJLZ24bXGhpiBwIMfEKIyxvuSqM_8'; // Replace with your spreadsheet ID

export const fetchSheetData = async (sheetName) => {
  try {
    if (!SHEETS_API_KEY) {
      throw new Error('Google Sheets API key is missing');
    }

    const response = await fetch(
      `https://sheets.googleapis.com/v4/spreadsheets/${SPREADSHEET_ID}/values/${sheetName}?key=${SHEETS_API_KEY}`,
      {
        headers: {
          'Accept': 'application/json',
        }
      }
    );

    if (!response.ok) {
      const errorData = await response.json();
      console.error('Google Sheets API Error:', errorData);
      throw new Error(`API request failed: ${errorData.error?.message || 'Unknown error'}`);
    }

    const data = await response.json();
    return data.values;
  } catch (error) {
    console.error('Error fetching sheet data:', error);
    throw error;
  }
};

export const sheetsConfig = {
  sheets: {
    about: 'About',
    portfolio: 'Portfolio',
    interests: 'Interests',
    contact: 'Contact'
  }
};
